import React, { useState, useEffect } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';

function CustomerRepresenterAddForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [customerRepresenterCode, setCustomerRepresenterCode] = useState('');
    const [isRepresent, setIsRepresent] = useState(false);

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset'
            }, "& .MuiSvgIcon-root": {
                position: 'inherit'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0"
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    useEffect(() => {
        setOpen(true);
        axios.get('/api/v1/Profile/HasAddedCustomerRepresenterCode', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then((res) => {
            setIsRepresent(res.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.post('/api/v1/Profile/AddCustomerRepresenter', null,
            {
                params: {
                    CustomerId: getAuthenticationToken().userID,
                    CustomerRepresenterCode: customerRepresenterCode
                }
            }
        ).then(response => {
            setMessageNotify({
                severity: "success",
                message: "کد معرف با موفقیت ثبت شد",
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ثبت معرف، کد معرف صحیح نمی باشد",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }
    const resultView = (isRepresent ?
        <Alert variant="filled" severity="warning" icon={false} style={{ marginBottom: '10px' }}>
            شما قبلا یک بار کد معرف ثبت کرده اید و امکان ثبت مجدد آن وجود ندارد.
        </Alert> :
        <>
            <Alert variant="filled" severity="info" icon={false} style={{ marginBottom: '10px' }}>
                جهت ثبت معرف کد دریافتی از ایشان را وارد نمائید
            </Alert>
            <form onSubmit={handleSubmit}>
                <Paper elevation={10} style={paperStyle} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="postalCode"
                                name="postalCode"
                                label="کد معرف"
                                fullWidth
                                variant="standard"
                                value={customerRepresenterCode}
                                onChange={e => setCustomerRepresenterCode(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                id="submit"
                                type='submit'
                                name="submit"
                                fullWidth
                                variant="contained"
                                color="success" >ثبت کد معرف</Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                onClick={() => { props.history.push('/') }}
                                id="cancel"
                                name="cancel"
                                fullWidth
                                variant="outlined"
                                color="error" >انصراف</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </form>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>)

    return (
        resultView
    );
}

export default withRouter(CustomerRepresenterAddForm);